import ApiClient from './ApiClient';
import PortOpeningRule from '../models/entities/PortOpeningRule';

export default class PortOpeningRuleService extends ApiClient {
	async getAllImplementedRulesBySubscription(subId: number, direction: string) {
		return this.get<PortOpeningRule[]>(`rules/implemented/${subId}/${direction}`);
	}
}
